
import { Options, Vue } from "vue-class-component";

@Options({})
export default class ComponentsFooterVue extends Vue {}
